import Backbone from "backbone";
import template from "./template.html";
import {FilterView} from "./filters";

const className = "fp-container";

let FloorPlanAppView = Backbone.View.extend({
    template,
    className,
    id: "floor_plan_app",
    events: {
        "click .fp-section-header > a": "selectTab",
        "click .fixed-nav-buttons > div > a": "mainViewTab",
        "shown.bs.tab .fp-section-header > a": "tabSelected"
    },
    initialize: function(options) {
        if (!options.mainView || !options.mapView) {
            throw new Error("App requires both main and map views");
        }

        this.firstRender = true;
        this.view = "main";
        this.hasMap = options.mapView.maps && options.mapView.maps.size > 0;
        this.resetToTop = options.resetToTop || false;
        this.resetDuration = options.resetDuration || 750;

        let filterOptions = {
            apartmentType: options.apartmentType,
            apartmentTypeLong: options.apartmentTypeLong
        };

        if (options.filterOptions) {
            filterOptions = _.extend(filterOptions, options.filterOptions);
        }

        filterOptions.collection = this.collection;

        this.children = {
            main: options.mainView,
            map: options.mapView,
            filter: new FilterView(filterOptions)
        };

        this.children.main.on("tabbed", (tab) => this.activateMainTab(tab));

        if (options.view) {
            this.setView(options.view);
        }
    },
    render: function() {
        this.repeatForChildren("render");
        this.el.className = `${className} ${this.renderSize}`;

        let context = {hasMap: this.hasMap};

        if (this.firstRender) {
            this.$el.html(this.template(context));
            this.$el.find(".fp-section-header").after(this.children.filter.el);
            this.$el.find(".tab-content")
                .append(this.children.main.el)
                .append(this.children.map.el);

            this.firstRender = false;

            if (window.location.hash === "#map") {
                setTimeout(() => {
                    document.querySelectorAll("#floorplan-list-controls")[1].classList.add("hide");
                }, 1000);
            }
        }

        this.delegateEvents();
        this.repeatForChildren("delegateEvents");

        this.collection.trigger("render:app");

        return this;
    },
    setView: function(view, trigger=true) {
        let selector = "#floorplans";
        const isActiveFloorplan = this.$el.find(".fp-selector").hasClass("active");

        if (view === "map") {
            selector = "#sitemap";
            this.view = view;
        } else {
            this.view = "main";
        }

        this.$el.find(`.fp-section-header > [href='${selector}']`).tab("show");

        if (trigger) {
            let fp = null;
            let unit = null;
            if (view === "main") {
                fp = this.floorPlan;
                unit = this.unit;
            }
            this.collection.trigger("nav", view, [fp, unit]);
            this.collection.trigger(`nav:${view}`, fp, unit);

            // Reset to default start if fp_selector is active
            if (view == "main" && isActiveFloorplan) {
                this.children.main.tab("#fp_view_start");
            }

            if (view == "main") {
                document.querySelectorAll("#floorplan-list-controls")[1].classList.remove("hide");
            } else {
                document.querySelectorAll("#floorplan-list-controls")[1].classList.add("hide");
            }

        }
    },
    selectTab: function(e) {
        e.preventDefault();
        let elem = e.currentTarget;
        let view = elem.getAttribute("data-tab");
        this.setView(view);
    },
    tabSelected: function(e) {
        let $elem = this.$el.find(e.currentTarget);
        if (!$elem.hasClass("active")) {
            this.$el.find(".fp-section-header > .active").removeClass("active");
            $elem.addClass("active");

            let $tab = this.$el.find(`.tab-content > ${$elem.attr("href")}`);
            if (!$tab.hasClass("active")) {
                this.$el.find(".fixed-nav > .active").removeClass("active");
                $tab.addClass("active");
            }
        }
    },
    mainViewTab: function(e) {
        e.preventDefault();
        let elem = e.currentTarget;
        this.children.main.tab(elem.hash);

        // Also make sure that we aren't on the site map.
        if (this.view !== "main") {
            this.setView("main");
        }
    },
    activateMainTab: function(tab) {
        this.$el.find(".fixed-nav-buttons > div > a").removeClass("active");
        this.$el.find(`.fixed-nav-buttons > div > [href="${tab}"]`).addClass("active");

        if (this.resetToTop) {
            $("html, body").animate(
                {scrollTop: $("#floor_plan_app:not(.fp-skeleton)").offset().top},
                this.resetDuration
            );
        }
    }
});

export {FloorPlanAppView};
